import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { codePickersId, CodeCodetablePickerProps } from './types';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { SinglePickerCreator } from 'app/area/indicator-factors/common/single-picker-creator';
import { endpoints } from 'app/area/indicator-factors/item/endpoints';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

interface CodeCodetablePickerState {
  id: string;
  loadOptionsParams: LoadOptions;
}
export class IndicatorSubstanceUom extends React.PureComponent<CodeCodetablePickerProps, CodeCodetablePickerState> {
  constructor(props: CodeCodetablePickerProps) {
    super(props);
    this.state = {
      id: undefined,
      loadOptionsParams: undefined
    };
  }

  public componentDidUpdate(prevPreps: CodeCodetablePickerProps) {
    const id = this.state.id;
    const loadOptionsParams = this.state.loadOptionsParams;

    if (!!prevPreps?.codetableOptions?.uomTypeIndicator?.fetching && !this.props?.codetableOptions?.uomTypeIndicator?.fetching) {
      const { loadOptions, codeItem } = this.props;

      loadOptions(id, endpoints.substanceUom, {
        ...loadOptionsParams,
        categoryId: undefined,
        siblingId: undefined,
        levels: undefined,
        indicatorSubstanceId: codeItem?.indicatorSubstance?.value
      });
    }
  }

  private onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    const { loadOptions, codeItem } = this.props;
    this.setState({ id, loadOptionsParams });

    loadOptions(
      id,
      endpoints.substanceUom,
      {
        ...loadOptionsParams,
        categoryId: undefined,
        siblingId: undefined,
        levels: undefined,
        code: { text: codeItem?.indicatorSubstance?.value },
        indicatorSubstanceId: codeItem?.indicatorSubstance?.value
      },
      {
        limitFieldsTo: []
      }
    );
  };

  private onChange = (value: CodeComplexValue<number>) => {
    const codetableKey = CodeFieldWireKey.indicatorSubstanceUom;

    this.props.resetValidation(codetableKey, value);
    this.props.onChange(codetableKey, value);
    this.props.clearAllValidation(codetableKey);
  };

  public render() {
    const { breadcrumbs, codeItem, translation, validation, readOnly, options } = this.props;
    const codetableKey = CodeFieldWireKey.indicatorSubstanceUom;
    const indicatorSubstanceKey = CodeFieldWireKey.indicatorSubstance;
    const codeOptions = (!!options[codetableKey] && options[codetableKey].codes || []) as CodeComplexValue<number>[];
    const isReadOnly = readOnly || (codeItem && !codeItem[indicatorSubstanceKey]);
    const fetching = !!options[codetableKey]?.fetching || !!options[CodeFieldWireKey.uomTypeIndicator]?.fetching;
    const currentValidation = !!validation && !!validation[codetableKey] ? validation[codetableKey] : undefined;
    const finalValidation = {
      ...currentValidation,
      ...getDisabledValidation(codeItem?.[codetableKey]?.disabled, translation.selected_value_disabled)
    };
    const indicatorSubstanceUomManageOptionsButton = manageOptionsButton(translation.manage_options,
      codePickersId.substanceUom, breadcrumbs);

    return <SinglePickerCreator
      id={codetableKey}
      label={translation.indicatorSubstanceUoM}
      valueItem={codeItem && codeItem[codetableKey]}
      searchRequired={false}
      required={!readOnly}
      readOnly={isReadOnly}
      minLength={1}
      options={codeOptions}
      fetchingOptions={fetching}
      translation={translation}
      onLoadOptions={this.onLoadOptions}
      onChange={this.onChange}
      extraFooterButton={indicatorSubstanceUomManageOptionsButton}
      validation={finalValidation}
    />;
  }
}
